import React from 'react';
import AppRoutes from './routes';
import { ToastProvider } from './components/toast/toast-context';

const App = () => {
  return (
    <ToastProvider>
      <AppRoutes />
    </ToastProvider>
  );
}

export default App;
